export default __webpack_public_path__ + "static/media/Placement.c684443a.pdf";